import React, { useState, useEffect } from 'react';
import '../../CSS/Global.css';
import { useSidebar } from '../../SidebarContext';
import Header from '../Header';
import Sidebar from '../SideBar';
import ReferModal from './ReferModal';
import { getDecryptedUserFromCookie } from '../utils/getCookie';
import Swal from 'sweetalert2';
import { ChevronLeft, ChevronRight, ChevronsLeft, ChevronsRight, Pencil, Trash2 } from 'lucide-react';
import { useSearch } from '../../SearchContext';
import Loader from '../Loader';
import { decryptToken } from '../utils/getToken';
import { useLocation } from 'react-router-dom';

const Refer = () => {

    const url = process.env.REACT_APP_LINK;
    const [isModalOpen, setIsModalOpen] = useState(false);
    const isLoggedIn = getDecryptedUserFromCookie("gta_mainstateuser");
    const [data, setData] = useState({
        image: "",
        title: "",
        description: "",
        offer_name: "",
        link: "",
        button_name: "",
        user_id: isLoggedIn.main_id,
        user_name: isLoggedIn.full_name,
    })
    const [slider, setSlider] = useState([])
    const [load, setLoad] = useState(false);
    const { globalSearch } = useSearch();
    const token = decryptToken("accessToken") || ""

    // State Variables
    const [searchQuery, setSearchQuery] = useState('');
    // const [ageGroups, setAgeGroups] = useState([
    //     // Sample data (replace with actual data)
    //     { minAge: 18, maxAge: 25, status: 'Active' },
    //     { minAge: 26, maxAge: 35, status: 'Deactive' },
    //     { minAge: 36, maxAge: 50, status: 'Active' },
    // ]);
    const [filteredAgeGroups, setFilteredAgeGroups] = useState(slider);
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;
    const location = useLocation()

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        if (params.get("openRefer") === "true") {
            const newUrl = `${window.location.pathname}`;
            window.history.replaceState({}, "", newUrl);
            setIsModalOpen(true)
        }
    }, [location]);

    // Effect to handle filtering
    useEffect(() => {
        const filtered = slider.filter((group) =>
            Object.values(group).some((value) =>
                String(value).toLowerCase().includes(globalSearch.toLowerCase())
            )
        );
        setFilteredAgeGroups(filtered);
        setCurrentPage(1); // Reset to first page on new search
    }, [globalSearch, slider]);

    // Pagination Logic
    const totalPages = Math.ceil(filteredAgeGroups.length / itemsPerPage);
    const currentData = filteredAgeGroups.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
    );

    // Handlers
    const handleSearch = (e) => setSearchQuery(e.target.value);

    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    // Toggle Status
    const toggleStatus = (index) => {
        setSlider((prevGroups) =>
            prevGroups.map((group, i) =>
                i === index
                    ? { ...group, status: group.status === 'Active' ? 'Deactive' : 'Active' }
                    : group
            )
        );
    };

    const handleDelete = async (id) => {
        const result = await Swal.fire({
            title: 'Are you sure?',
            text: "This will permanently delete the slider!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
        });

        if (result.isConfirmed) {
            try {
                const response = await fetch(`${url}/offer/${id}`, {
                    method: "DELETE",
                    headers: {
                        Authorization: `Bearer ${token}`,
                    }
                });

                const res = await response.json();

                if (response.ok) {
                    Swal.fire('Deleted!', 'Offer has been deleted.', 'success');
                    sliderFetch(); // Refresh the slider list
                } else {
                    Swal.fire('Error!', res.message || 'Failed to delete.', 'error');
                }
            } catch (error) {
                Swal.fire('Error!', 'Something went wrong.', 'error');
                console.error(error);
            }
        }
    };
    const sliderFetch = async () => {
        setLoad(true)
        try {
            const response = await fetch(`${url}/offer/all/${isLoggedIn.main_id}`)
            const res = await response.json();
            ;
            setSlider(res);
        } catch (error) {
            console.error(error);
        } finally {
            setLoad(false)
        }
    }

    useEffect(() => {
        sliderFetch();
    }, [])

    if (load) {
        return (
            <Loader />
        );
    }

    return (
        <>
            <div className="oms-header">
                <h1 className="dashboard-title">Referral</h1>
            </div>

            {/* Search Filter */}
            {/* <div className="filter-search">
                    <div className="filter-search-input">
                        <input
                            type="search"
                            placeholder="Search..."
                            value={searchQuery}
                            onChange={handleSearch}
                        />
                        <i className="fa fa-search"></i> 
                    </div>
                </div> */}

            {/* Age Groups Table */}
            <div className="customer-table responsive-table">
                <table>
                    <thead>
                        <tr>
                            <th>Referral Usage</th>
                            <th>Times Allowed</th>
                            <th>Prize Type</th>
                            <th>Prize Value</th>
                            <th>Start Date</th>
                            <th>Stop Date</th>
                            <th>Notify User</th>
                            <th>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {currentData.length > 0 ? (
                            currentData.map((refer, index) => (
                                <tr key={index}>
                                    <td>{refer.referralType === "one" ? "One Time" : "Multiple Time"}</td>
                                    <td>{refer.referralType === "multiple" ? refer.referralTimes : "-"}</td>
                                    <td>{refer.prizeType}</td>
                                    <td>
                                        {refer.prizeType === "amount"
                                            ? `₹${refer.prizeValue}`
                                            : `${refer.prizeValue}%`}
                                    </td>
                                    <td>{refer.startDate || "N/A"}</td>
                                    <td>{refer.endDate || "N/A"}</td>
                                    <td>{refer.notifyUser ? "Yes" : "No"}</td>
                                    <td>
                                        <button
                                            className="edit-button"
                                            onClick={() => {
                                                setData(refer);
                                                setIsModalOpen(true);
                                            }}
                                        >
                                            <i className="fa-solid fa-pencil edit-oms"></i>
                                        </button>

                                        <button
                                            className="delete-button"
                                            onClick={() => handleDelete(index)}
                                        >
                                            <i className="fa-solid fa-trash delete-oms"></i>
                                        </button>
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="8" style={{ textAlign: "center" }}>
                                    No referral settings found.
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>


            <div className="ecom-responsive-cards">
                {currentData.length === 0 ? (
                    <p style={{ textAlign: "center", margin: "50px" }}>No Offer Added</p>
                ) : (
                    currentData.map((group, index) => (
                        <div className="ecom-responsive-card"
                            key={index}>

                            <div className="ecom-responsive-header">
                                <p onClick={() => {
                                    let parsedProduct = group.product;

                                    try {
                                        // Handle double-stringified product
                                        if (typeof parsedProduct === "string") {
                                            parsedProduct = JSON.parse(parsedProduct);
                                            if (typeof parsedProduct === "string") {
                                                parsedProduct = JSON.parse(parsedProduct);
                                            }
                                        }
                                    } catch (e) {
                                        console.warn("Error parsing product:", e);
                                        parsedProduct = {}; // fallback
                                    }

                                    setData({
                                        ...group,
                                        product: parsedProduct,
                                    });

                                    setIsModalOpen(true);
                                }}><Pencil size={20} /> <span>Edit</span></p>
                                <p><Trash2 size={20} onClick={() => handleDelete(group.id)} /> <span>Delete</span></p>
                            </div>

                            <div className="ecom-responsive-body">
                                <div className="ecom-responsive-left">
                                    <h2>{group.title || "Not Provided"}</h2>
                                    <p>{group.link}</p>
                                    {/* <div className="ecom-card-images">
                                            <div>
                                                <p>Main Image</p>
                                                <img src={group.image} alt="" style={{ width: "50px", height: "50px" }} />
                                            </div>
                                            <div>
                                                <p>Background Image</p>
                                                <img src={group.background_image} style={{ width: "50px", height: "50px" }} alt="" />
                                            </div>
                                        </div> */}
                                </div>

                                {/* <div className="ecom-responsive-right">
                                        <h4>₹{group.price}</h4>
                                        <p>₹{group.cutOffPrice}</p>
                                    </div> */}
                            </div>
                        </div>
                    ))
                )}

            </div>
            {totalPages > 1 && (

                <div className="pagination">
                    {/* First Page */}
                    <button
                        onClick={() => paginate(1)}
                        disabled={currentPage === 1}
                        className="pagination-chev-btn"
                    >
                        <ChevronsLeft size={18} />
                    </button>

                    {/* Previous Page */}
                    <button
                        onClick={() => paginate(currentPage - 1)}
                        disabled={currentPage === 1}
                        className="pagination-chev-btn"
                    >
                        <ChevronLeft size={18} />
                    </button>

                    {/* Current Page Number Only */}
                    <button className="pagination-btn active">
                        {currentPage}
                    </button>

                    {/* Next Page */}
                    <button
                        onClick={() => paginate(currentPage + 1)}
                        disabled={currentPage === totalPages}
                        className="pagination-chev-btn"
                    >
                        <ChevronRight size={18} />
                    </button>

                    {/* Last Page */}
                    <button
                        onClick={() => paginate(totalPages)}
                        disabled={currentPage === totalPages}
                        className="pagination-chev-btn"
                    >
                        <ChevronsRight size={18} />
                    </button>
                </div>
            )}

            <div className="fixed bottom-6 left-1/2 transform -translate-x-1/2 z-50">
                <button
                    onClick={() => {
                        // Reset the form to default empty values
                        setData({
                            image: "",
                            title: "",
                            description: "",
                            link: "",
                            offer_name: "",
                            button_name: "",
                            user_id: isLoggedIn.main_id,
                            user_name: isLoggedIn.full_name,
                        });
                        setIsModalOpen(true);
                    }}
                    className="cssbuttons-io-button">
                    <span>Add Referral</span>
                </button>
            </div>

            <ReferModal isOpen={isModalOpen} setIsOpen={setIsModalOpen} data={data} setData={setData} />
        </>
    );
};

export default Refer;
